var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseRedX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7 13.125A6.125 6.125 0 1 0 7 .875a6.125 6.125 0 0 0 0 12.25z",
    fill: "#D01400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65 7 9.057 5.59a.462.462 0 0 0 0-.65.462.462 0 0 0-.65 0L7 6.352 5.59 4.94a.462.462 0 0 0-.65 0 .462.462 0 0 0 0 .65L6.352 7 4.94 8.409a.462.462 0 0 0 0 .649.454.454 0 0 0 .325.135.454.454 0 0 0 .325-.135L7 7.649l1.409 1.409a.454.454 0 0 0 .324.135.454.454 0 0 0 .325-.135.462.462 0 0 0 0-.65L7.649 7z",
    fill: "#D01400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseRedX);
export default __webpack_public_path__ + "static/media/ic-close-red-x.5292c36c0c2e83e8d0df36bc6d7793c4.svg";
export { ForwardRef as ReactComponent };